module.exports = __webpack_public_path__ + "static/media/slider_mobile.ca21332b.jpg";